
// @todo: Move this to /core/zindex
// @todo: Move thist ot $ui.zIndex in all components
//        don't for get to inject $ui in the components.
// @todo: Include it in the config (obviously)
//

function handler() {
  let zIndexes = [];
  const generateZIndex = (key, autoZIndex, baseZIndex= 999) => {
    const lastZIndex = getLastZIndex(key, autoZIndex, baseZIndex);
    const newZIndex = lastZIndex.value + (lastZIndex.key === key ? 0 : baseZIndex) + 1;
    zIndexes.push({ key, value: newZIndex });

    return newZIndex;
  };

  const revertZIndex = (zIndex) => {
    zIndexes = zIndexes.filter((obj) => obj.value !== zIndex);
  };

  const getCurrentZIndex = (key, autoZIndex) => {
    return getLastZIndex(key, autoZIndex).value;
  };

  const getLastZIndex = (key, autoZIndex, baseZIndex=0) => {
    return [...zIndexes].reverse().find((obj) => (autoZIndex ? true : obj.key === key)) || { key, value: baseZIndex };
  };

  const getZIndex = (element) => {
    // eslint-disable-next-line radix
    return element ? parseInt(element.style.zIndex, 10) || 0 : 0;
  };

  return {
    get: getZIndex,
    set: (key, element, baseZIndex) => {
      if (element) {
        element.style.zIndex = String(generateZIndex(key, true, baseZIndex));
      }
    },
    clear: (element) => {
      if (element) {
        revertZIndex(getZIndex(element));
        element.style.zIndex = '';
      }
    },
    getCurrent: (key) => getCurrentZIndex(key, true)
  };
}

export const ZIndex = handler();
